/**
 * Find the name to display for a given component
 * Taken from react-redux.
 */
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default getDisplayName;